export default "__VITE_ASSET__CjNEqcqm__"